<div class="korviu-loader">
  <ng-template #indicatorTemplate><nz-icon nzType="loading" /></ng-template>
  <nz-spin nzSimple [nzIndicator]="indicatorTemplate"></nz-spin>
</div>
